import styles from "./Detail.module.scss";
import cx from "classnames";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { useStrapiContext } from "@providers/StrapiProvider";
import getter from "@services/StoryArticleService/getter";
import { useTranslationContext } from "@providers/TranslationProvider";

const View = () => {
  const { article } = usePageContext();
  const { i18n } = useTranslationContext();
  const { str } = useStrapiContext();

  return (
    <section data-scroll-section className={styles.section}>
      {str.renderComp(getter.details(article))}
      <div className={cx("inner-article text-black-1", styles.tags)}>
        <b>{i18n.t("Stories.tags")}:</b> {getter.tags(article)}
      </div>
    </section>
  );
};
export default View;
